import { bindActionCreators } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ElasticVehicle } from '../../@types/ElasticVehicle';
import { history } from '../../actions/history';
import { trackClickItemEvent, trackExposureEvent } from '../../actions/tracking';
import QueryFilter from '../../helpers/query-filter';
import type { RootState } from '../../reducers';
import { ProductGridItem } from '../../styled-components/components/ProductGrid';
import ProductCard, { type PrimaryPriceOptions } from '../product-card-v2';

interface ResultSetItemProps {
  document: ElasticVehicle;
  index: number;
  title?: string;
  testId?: string;
}

const ResultSetItem = ({ document, index, title, testId }: ResultSetItemProps) => {
  const dispatch = useDispatch();

  const queryFilter = useSelector<RootState, string | null>((s) => s.search.queryFilter);
  const actions = bindActionCreators(
    {
      history,
      trackExposureEvent,
      trackClickItemEvent,
    },
    dispatch,
  );

  const onTrackExposure = () =>
    actions.trackExposureEvent(document, new QueryFilter(queryFilter).toString(), index, title);

  const onClick = () => {
    actions.trackClickItemEvent(document, index, title);
    if (queryFilter) {
      actions.history(new QueryFilter(queryFilter));
    }
  };

  // Set primary price based on price filter applied
  let primaryPrice = 'price';

  if (queryFilter?.includes('leasing=true')) {
    primaryPrice = 'privateLeasing';
  } else if (queryFilter?.includes('businessLeasing=true')) {
    primaryPrice = 'businessLeasing';
  }

  return (
    <ProductGridItem>
      <ProductCard
        item={document}
        onClick={onClick}
        onExposure={onTrackExposure}
        primaryPrice={primaryPrice as PrimaryPriceOptions}
        testId={testId}
      />
    </ProductGridItem>
  );
};

export default ResultSetItem;
